import { usePaymentApiV1 } from '../../../clients/quipli-service/payment/payment-api-v1';
import { useEffect, useState } from 'react';
import { Modal } from '../../../components/modal/modal';
import { Typography } from '../../../components/typography/typography';
import { LocationSelect } from '../../location/select/location-select';
import { Field } from '../../../components/field/field';
import { Spinner } from '../../../components/spinner/spinner';
import { Location } from '../../../clients/quipli-service/location/location';
import { toast } from '../../../util/toasts';

export const AddTerminalForm = ({
  isOpen,
  close,
  terminalId,
}: {
  isOpen: boolean;
  close: () => any;
  terminalId?: string;
}) => {
  const { addTerminal, updateTerminal } = usePaymentApiV1();
  const [pairingCode, setPairingCode] = useState<string>('');
  const [label, setLabel] = useState<string>('');
  const [location, setLocation] = useState<Location | null>(null);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsDisabled(label.length === 0 || (!terminalId && (pairingCode.length === 0 || !location)));
  }, [pairingCode, label, location]);

  const onSubmit = async () => {
    if (isDisabled) return;
    setIsLoading(true);

    if (terminalId && label && label != '') {
      try {
        await updateTerminal(terminalId, label);
        setIsLoading(false);
        close();
      } catch (e: any) {
        setIsLoading(false);
        if (e.message.msg) {
          toast(e.message.msg, 'error');
        } else if (e.message) {
          toast(e.message, 'error');
        }
      }
    } else if (location && pairingCode != '' && label != '') {
      try {
        await addTerminal(location.id, pairingCode, label);
        setIsLoading(false);
        close();
      } catch (e: any) {
        setIsLoading(false);
        if (e.message.msg) {
          toast(e.message.msg, 'error');
        } else if (e.message) {
          toast(e.message, 'error');
        }
      }
    }
  };

  return (
    <Modal
      title="Set up a card reader"
      isOpen={isOpen}
      close={() => close()}
      actions={
        isLoading ? (
          <Spinner />
        ) : (
          <>
            <button className="button button-block button-secondary" data-cy="cancel_terminal" onClick={() => close()}>
              Cancel
            </button>

            <button
              className="button button-yellow button-primary"
              data-cy="confirm_terminal"
              onClick={onSubmit}
              disabled={isDisabled}
            >
              {'Save'}
            </button>
          </>
        )
      }
    >
      {!terminalId && (
        <>
          <div>
            <Typography type={'text-sm'}>Location: </Typography>
            <LocationSelect setLocation={setLocation} />
          </div>
          <Field label="Pairing code" dataCy="pairing_code" type="text" value={pairingCode} onChange={setPairingCode} />
        </>
      )}
      <Field label="Label" dataCy="label" type="text" value={label} onChange={setLabel} />
    </Modal>
  );
};
